import React from 'react';
import moment from 'moment';
import { optionDateLabel } from '@features/RoomRateConfigurationWizard/FormSteps/ExtrasStep/Extras/Options/optionDateLabel';
import BlockSelectField from '@common/components/FormElements/BlockSelectField';
import { useIsWindowWiderThan } from '@common/hooks/useIsWindowWiderThan';
import { gridTheme } from '@utils/grid';

const optionsForPerDateRange = (options, isMobile) => {
  return options.map((option, index) => {
    const startDate = moment(option.startDate).format('MMM DD');
    const endDate = moment(option.endDate).format('MMM DD');
    const labelDate = startDate === endDate ? startDate : `${startDate} - ${endDate}`;

    return {
      label: optionDateLabel(labelDate, option.name, isMobile),
      value: index,
    };
  });
};

export const PerDateRange = ({ field, options }) => {
  return (
    <BlockSelectField
      onChange={(value) => {
        field.onChange(value);
      }}
      value={field.value}
      options={optionsForPerDateRange(options, !useIsWindowWiderThan(gridTheme.breakpoints.md))}
    />
  );
};
